import { Dictionary } from "@lcms/helpers";

export function getLoggingContextParams(folder?: { loggingContext?: Dictionary<string> } | null) {
    const queryParams = typeof window !== 'undefined' ?
        {
            host: new URL(window.location.href).searchParams.get('host')
        } : {}

    const context = {
        ...folder?.loggingContext || {},
        ...queryParams
    } as Dictionary<string>;

    const keys = Object.keys(context).filter(key => context[key]);

    return keys.length ?
        ('?' + keys.map(key => `${key}=${encodeURIComponent(context[key])}`).join('&'))
        : ''
}